import { ScheduledProctoringSession } from "@cs124/questionable"
import { Protocol } from "gravatar"
import moment from "moment-timezone"
import { String } from "runtypes"

export const DEVELOPMENT = !!process.env.NEXT_PUBLIC_DEVELOPMENT

export const COOKIE_DOMAIN = DEVELOPMENT ? "cs124.local" : "cs124.org"

export const PERSONABLE_SERVER = String.check(process.env.NEXT_PUBLIC_PERSONABLE_SERVER)
export const SHAREABLE_SERVER = String.check(process.env.NEXT_PUBLIC_SHAREABLE_SERVER)
export const QUESTIONER_SERVER = String.check(process.env.NEXT_PUBLIC_QUESTIONER_SERVER)
export const STUMPER_SERVER = String.check(process.env.NEXT_PUBLIC_STUMPER_SERVER)
export const QUESTIONABLE_SERVER = String.check(process.env.NEXT_PUBLIC_QUESTIONABLE_SERVER)
export const MACE_SERVER = String.check(process.env.NEXT_PUBLIC_MACE_SERVER)
export const HELPABLE_SERVER = String.check(process.env.NEXT_PUBLIC_HELPABLE_SERVER)
export const JITSI_SERVER = String.check(process.env.NEXT_PUBLIC_JITSI_SERVER)
export const API_SERVER = String.check(process.env.NEXT_PUBLIC_API_SERVER)
export const JEED_SERVER = String.check(process.env.NEXT_PUBLIC_JEED_SERVER)

export const CURRENT_NUMBER = "124"
export const MAX_ASSISTANT_CONTRIBUTION_COUNT = 4

export const REFERENCE_SEMESTER_SHORTHAND = "Spring2025"

export const MP_STAFF_RELEASED = true
export const MP_RELEASED = true

export const ZOOM_MEETING_ID = "873 9898 8147"

export const OLD_SEMESTERS = [
  { name: "Fall 2020", shorthand: "Fall2020" },
  { name: "Spring 2021", shorthand: "Spring2021" },
  { name: "Summer 2021", shorthand: "Summer2021" },
]

export const VALID_SEMESTERS = [
  { name: "Fall 2021", shorthand: "Fall2021" },
  { name: "Spring 2022", shorthand: "Spring2022" },
  { name: "Summer 2022", shorthand: "Summer2022" },
  { name: "Fall 2022", shorthand: "Fall2022" },
  { name: "Spring 2023", shorthand: "Spring2023" },
  { name: "Summer 2023", shorthand: "Summer2023" },
  { name: "Fall 2023", shorthand: "Fall2023" },
  { name: "Spring 2024", shorthand: "Spring2024" },
  { name: "Fall 2024", shorthand: "Fall2024" },
  { name: "Spring 2025", shorthand: "Spring2025" },
  { name: "Summer 2025", shorthand: "Summer2025" },
]

export const ALL_SEMESTERS = [...OLD_SEMESTERS, ...VALID_SEMESTERS]

export type ValidSemesters =
  | "Fall2021"
  | "Spring2022"
  | "Summer2022"
  | "Fall2022"
  | "Spring2023"
  | "Summer2023"
  | "Fall2023"
  | "Spring2024"
  | "Fall2024"
  | "Spring2025"
  | "Summer2025"

export const GRAVATAR_OPTIONS = {
  r: "pg",
  s: "120",
  d: encodeURI("https://www.cs124.org/images/logo-120x120.png"),
  protocol: "https" as Protocol,
}

export const LARGE_GRAVATAR_OPTIONS = {
  r: "pg",
  s: "460",
  d: encodeURI("https://www.cs124.org/images/logo-460x460.png"),
  protocol: "https" as Protocol,
}

export const WORKAHEAD = 2
export const WORKBEHIND = DEVELOPMENT ? 1 : 1

export const DEFAULT_STUMPER_SKIP_COUNT = 2
export const DEFAULT_STUMPER_CHECK_COUNT = 2

export const DISABLE_QUIZ_SECURITY = !!process.env.NEXT_PUBLIC_DISABLE_QUIZ_SECURITY

export const PROCTORING_SESSIONS: ScheduledProctoringSession[] = [
  {
    sessionID: "54811e61-ea2c-426c-b6e2-52a7f257faa9",
    duration: 50,
    start: moment.tz("2025-08-07T08:50:00", "America/Chicago").toDate(),
    end: moment.tz("2025-08-07T11:00:00", "America/Chicago").toDate(),
  },
  {
    sessionID: "ed3b3051-0e8e-4ab1-81c6-c411eb46a12f",
    duration: 50,
    start: moment.tz("2025-08-04T08:50:00", "America/Chicago").toDate(),
    end: moment.tz("2025-08-04T11:00:00", "America/Chicago").toDate(),
  },
  {
    sessionID: "fd9da941-6b4c-4d3c-9401-3e346d2ae981",
    duration: 50,
    start: moment.tz("2025-07-31T08:50:00", "America/Chicago").toDate(),
    end: moment.tz("2025-07-31T11:00:00", "America/Chicago").toDate(),
  },
  {
    sessionID: "e6c480f0-1634-440b-909e-b2de42da403d",
    duration: 50,
    start: moment.tz("2025-07-28T08:50:00", "America/Chicago").toDate(),
    end: moment.tz("2025-07-28T11:00:00", "America/Chicago").toDate(),
  },
  {
    sessionID: "771bec1c-9d4a-4159-b2ef-d34c518f1fdd",
    duration: 50,
    start: moment.tz("2025-07-24T08:50:00", "America/Chicago").toDate(),
    end: moment.tz("2025-07-24T11:00:00", "America/Chicago").toDate(),
  },
  {
    sessionID: "79e6a536-a16e-42d2-b646-dc8a8126b0be",
    duration: 50,
    start: moment.tz("2025-07-21T08:50:00", "America/Chicago").toDate(),
    end: moment.tz("2025-07-21T11:00:00", "America/Chicago").toDate(),
  },
  {
    sessionID: "e71c80c5-7853-4acd-978e-c24ed494f293",
    duration: 50,
    start: moment.tz("2025-07-17T08:50:00", "America/Chicago").toDate(),
    end: moment.tz("2025-07-17T11:00:00", "America/Chicago").toDate(),
  },
  {
    sessionID: "4fe714d8-1ab9-46eb-a09a-f973602b28cc",
    duration: 50,
    start: moment.tz("2025-07-14T08:50:00", "America/Chicago").toDate(),
    end: moment.tz("2025-07-14T11:00:00", "America/Chicago").toDate(),
  },
  {
    sessionID: "b402686f-4f93-4256-af69-74d38a683e2d",
    duration: 50,
    start: moment.tz("2025-07-10T08:50:00", "America/Chicago").toDate(),
    end: moment.tz("2025-07-10T11:00:00", "America/Chicago").toDate(),
  },
  {
    sessionID: "55c654eb-4453-45a8-bc3a-e02bcb7999b1",
    duration: 50,
    start: moment.tz("2025-07-07T08:50:00", "America/Chicago").toDate(),
    end: moment.tz("2025-07-07T11:00:00", "America/Chicago").toDate(),
  },
  {
    sessionID: "1e35b042-ed0d-402f-9305-1efc1b53f4cf",
    duration: 50,
    start: moment.tz("2025-07-03T08:50:00", "America/Chicago").toDate(),
    end: moment.tz("2025-07-03T11:00:00", "America/Chicago").toDate(),
  },
  {
    sessionID: "2c62190d-11b8-4e5a-b0f0-1d3b8456347c",
    duration: 50,
    start: moment.tz("2025-06-30T08:50:00", "America/Chicago").toDate(),
    end: moment.tz("2025-06-30T11:00:00", "America/Chicago").toDate(),
  },
  {
    sessionID: "674d9d37-9553-4dc0-bdbc-d07442564445",
    duration: 50,
    start: moment.tz("2025-06-26T08:50:00", "America/Chicago").toDate(),
    end: moment.tz("2025-06-26T11:00:00", "America/Chicago").toDate(),
  },
  {
    sessionID: "1e8d16f5-fa45-4193-b0f3-1fc6e6af2fc3",
    duration: 50,
    start: moment.tz("2025-06-23T08:50:00", "America/Chicago").toDate(),
    end: moment.tz("2025-06-23T11:00:00", "America/Chicago").toDate(),
  },
  ...(DEVELOPMENT
    ? [
        {
          sessionID: "28cc704f-3abf-438e-9028-5820ef2d083a",
          duration: 30,
          start: moment().toDate(),
          end: moment().add(1, "hour").toDate(),
          development: true,
        },
      ]
    : []),
]

export const QUIZ_PREFIX = "/quizzes/"
export const IN_CBTF = false
export const SHOW_PROCTORING_ZOOM = !!ZOOM_MEETING_ID
export const NO_LANGUAGE_REDIRECT = false

export const DISABLE_COOKIE_WARNING = false

export const DEFAULT_AUTHOR = "challen@illinois.edu"

export const DEFAULT_DEADLINES = {
  Fall2023: {
    EARLY_HW: "2023-09-05",
  },
  Spring2024: {
    RELEASE_DATE: "2024-01-12",
    EARLY_HW: "2024-01-31",
  },
  Fall2024: {
    RELEASE_DATE: "2024-08-23",
    EARLY_HW: "2024-09-11",
    MP_RELEASE: "2024-10-28",
  },
  Spring2025: {
    RELEASE_DATE: "2025-01-21",
    ...(!process.env.NO_EARLY_HW && { EARLY_HW: "2025-02-05" }),
    MP_RELEASE: "2025-03-31",
  },
  Summer2025: {
    RELEASE_DATE: "2025-06-13",
    ...(!process.env.NO_EARLY_HW && { EARLY_HW: "2025-06-27" }),
    MP_RELEASE: "2025-07-16",
  },
}

export const ASSISTANT_TRAINING = true

export const DEFAULT_PRACTICE_COUNT = 8
export const DEFAULT_LATE_PENALTY_PER_DAY: { [key in ValidSemesters]?: number } = { Fall2024: 2 }
export const DEFAULT_LATE_DAYS: { [key in ValidSemesters]?: number } = { Spring2025: 4, Summer2025: 4 }

export const SHOW_VERSION_WARNINGS = true

export const MAX_TIME_DIFF_SECONDS = 60
export const DEVELOPMENT_BUILDID = !!process.env.NEXT_PUBLIC_DEVELOPMENT_BUILDID

export const STATIC_ACE_VERSION = "1.43.1"
export const SHOW_MENTORING = false

export const CALENDAR_IDS: Record<string, string> = {
  Summer2025: "c_3e9014cd714120a39cdd16abbbd02cc1b61c0a5c2e980536a29d0f5b662ebfb5@group.calendar.google.com",
}
